export default "__VITE_ASSET__DwDBX8TQ__"